module.exports = __webpack_public_path__ + "static/media/ic_reciver.c3066008.svg";